import { render, staticRenderFns } from "./En_newsdetail.vue?vue&type=template&id=2d1fc647&scoped=true"
import script from "./En_newsdetail.vue?vue&type=script&lang=js"
export * from "./En_newsdetail.vue?vue&type=script&lang=js"
import style0 from "./En_newsdetail.vue?vue&type=style&index=0&id=2d1fc647&prod&scoped=true&lang=css"
import style1 from "./En_newsdetail.vue?vue&type=style&index=1&id=2d1fc647&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1fc647",
  null
  
)

export default component.exports